import { RecipientModificationAction, RecipientModifications, CsvToRecipientData } from './types'

const buildModificationsInfo = (
    currentSavedRecipients: CsvToRecipientData[],
    importedRecipients: CsvToRecipientData[]
): RecipientModifications[] => {
    const modifications = [] as RecipientModifications[]

    if (currentSavedRecipients && Array.isArray(currentSavedRecipients) && currentSavedRecipients !== null) {
        currentSavedRecipients
            .filter(
                obj => !!obj && !!obj.errors && !!obj.recipient && !!obj.recipient.name && obj.recipient.name.trim() !== ''
            )
            .forEach(({ errors, recipient }) => {
                modifications.push({
                    groupName: recipient.name,
                    errors: [...errors],
                    action: RecipientModificationAction.DELETED,
                    currentRecipient: recipient
                } as RecipientModifications)
            })
    }

    if (importedRecipients && Array.isArray(importedRecipients) && importedRecipients !== null) {
        importedRecipients
            .filter(
                obj =>
                    !!obj && !!obj.errors && !!obj.recipient && !!obj.recipient.name && obj.recipient.name.trim() !== ''
            )
            .forEach(({ errors, recipient }) => {
                const modificationIdx = modifications.findIndex(m => m.groupName === recipient.name)
                if (modificationIdx != -1) {
                    modifications[modificationIdx] = {
                        ...modifications[modificationIdx],
                        errors: [...errors, ...modifications[modificationIdx].errors],
                        importedRecipient: recipient,
                        action: RecipientModificationAction.UPDATED
                    } as RecipientModifications
                } else {
                    modifications.push({
                        groupName: recipient.name,
                        errors: [...errors],
                        action: RecipientModificationAction.ADDED,
                        importedRecipient: recipient
                    } as RecipientModifications)
                }
            })
    }
    return modifications
}

export default buildModificationsInfo
